// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const blogsApi = createApi({
  reducerPath: "blogsApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getReferralList", "getBundleList", "getTagsList"],
  endpoints: (builder) => ({
    getBlogList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getReferralList"],
    }),

    getBlogById: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: [""],
    }),

    CreateBlog: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["getReferralList"],
    }),
    updateBlog: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
        };
      },
      invalidatesTags: [""],
    }),
    //verified
    updateVerifiedStatus: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
        };
      },
      invalidatesTags: [""],
    }),
    // tags Section
    getTagsList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getTagsList"],
    }),

    useHandleDelete: builder.mutation({
      query: (endpoint) => ({
        url: `${endpoint}`,
        method: "DELETE",
      }),

    }),

    createTag: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["getTagsList"],
    }),
    //get categories

    getSelectList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getTagsList"],
    }),
  }),
});

export const {
  useGetBlogListQuery,
  useGetBlogByIdQuery,
  useCreateBlogMutation,
  useUpdateBlogMutation,
  useCreateTagMutation,
  useGetTagsListQuery,
  useGetSelectListQuery,
  useUseHandleDeleteMutation,
  useUpdateVerifiedStatusMutation
} = blogsApi;
